module.exports = "<app-navbar></app-navbar>\n<div class=\"container\">\n    <div class=\"main-not-found\">\n        Hello human, the page you are looking for cannot be found! <br>\n        How about a coffee break? ;)\n    </div>\n    <div class=\"main\">\n        <img src=\"../../../assets/images/page_not_found.jpg\" class=\"img-fluid\" alt=\"Responsive image\">\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/pagenotfound/pagenotfound.component.html
// module id = ./src/app/main/pagenotfound/pagenotfound.component.html
// module chunks = main